/**
 * @flow
 * @relayHash a0827b20a4431e75db56da41f52eb874
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddWarehouseLocationInput = {|
  name: string,
  code?: ?string,
  description?: ?string,
|};
export type AddWarehouseLocationMutationVariables = {|
  input: AddWarehouseLocationInput
|};
export type AddWarehouseLocationMutationResponse = {|
  +addWarehouseLocation: {|
    +warehouseLocationEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +name: string,
        +code: ?string,
        +description: ?string,
        +isActive: boolean,
        +updatedAt: ?any,
        +createdAt: ?any,
      |},
    |}
  |}
|};
export type AddWarehouseLocationMutation = {|
  variables: AddWarehouseLocationMutationVariables,
  response: AddWarehouseLocationMutationResponse,
|};
*/


/*
mutation AddWarehouseLocationMutation(
  $input: AddWarehouseLocationInput!
) {
  addWarehouseLocation(input: $input) {
    warehouseLocationEdge {
      cursor
      node {
        id
        name
        code
        description
        isActive
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddWarehouseLocationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addWarehouseLocation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddWarehouseLocationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "warehouseLocationEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "WarehouseLocationEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isActive",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddWarehouseLocationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddWarehouseLocationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddWarehouseLocationMutation",
    "id": null,
    "text": "mutation AddWarehouseLocationMutation(\n  $input: AddWarehouseLocationInput!\n) {\n  addWarehouseLocation(input: $input) {\n    warehouseLocationEdge {\n      cursor\n      node {\n        id\n        name\n        code\n        description\n        isActive\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2e711976786f2422ac6003667b80bdc3';
module.exports = node;
